import {STORE_OAUTH_TOKEN} from '../constants'

export default (state = {}, action = {}) => {
  switch (action.type) {
    case STORE_OAUTH_TOKEN:
      return {
        ...state,
        ...action.tokenInfo,
      }
    default:
      return state
  }
}
